import styled from 'styled-components';

const Wrapper = styled.div`
    position: relative;
    .pop-up-content .container {
        margin-top: 3.5rem;
    }
    .d-flex {
        display: flex;
    }
    .btn-wrapper {
        display: flex;
        justify-content: space-between;
        padding: 10px;
    }
    .content-panel {
        padding: 32px 100px;
    }
    .rounded-btn {
        .ant-btn {
            border-radius: 15px;
            font-size: 12px;
            min-width: 4rem;
            line-height: 1;
            height: 26px;
            padding: 0px 6px;
        }
    }
    .disabled-btn {
        .ant-btn {
            border-color: #212121 !important;
            color: #fff;
            background-color: #42454D;
        }
    }
    .KYC_PLUGIN_ICON {
        width: 5rem;
    }
    .box-wrapper {
        border: 1px solid #A8A8B1;
        width: 400px;
        border-radius: 7px;
    }
    .box-text-wrapper {
        color: #fff;
        margin-left: 1rem;
    }
    .content-title {
        color: #fff;
        font-weight: bold;
    }
    .box-container {
        background: #212121;
        padding: 3rem 1rem;
        border-radius: 7px 7px 0px 0px;
        .cloud-icon {
            width: 3.5rem;
            height: 3.5rem;
		}
    }
    .font-green {
        color: #288500;
    }
    .font-red {
        color: #FF8800;
    }
    .warning-wrapper {
        display: flex;
        align-items: center;
        .small-round {
            width: 14px;
            height: 14px;
            border: 1px solid #707070;
            border-radius: 50%;
            margin: 0px 6px 2px 0;
        }
        .warning {
            background-color: #FF8800;
            border-color: #FF8800 !important;
        }
    }
    .warn-text {
        font-size: 12px;
        max-width: 400px;
        margin-top: 1rem;
    }
    .content {
        padding: 1rem 2rem;
        .sub-title {
            font-size: 18px;
            font-weight: bold;
        }
        .button-wrapper {
            display: flex;
            align-items: center;
            .divider {
                margin: 0.25rem;
            }
        }
    }
    .divider {
        margin: 0.5rem;
    }
    .box {
        /* width: fit-content; */
        padding: 2rem 3rem;
        background: #212121;
    }
    .flex-center {
		display: flex;
		align-items: center
	}

    @media (max-width: 425px) {
        .flex-center {
		    display: block;
            .KYC_PLUGIN_ICON {
                display: flex;
                justify-content: center;
                width: 100%;
                img {
                    width: 5rem;
                }
            }
	    }
    }

    @media(max-width: 960px) {
        .content-panel {
            padding: 20px;
        }
        .box-wrapper {
            width: 260px;
        }
        .box-container {
            padding: 2rem 1rem;
        }
        .KYC_PLUGIN_ICON {
            min-width: 5rem;
        }
        .main-header {
            font-size: 20px;
        }
        .warn-text {
            max-width: 230px;
        }
    }
`;

export const ModelWrapper = styled.div`
    color: #fff;
    .kyc-icon {
        width: 3rem;
    }
    .title {
        font-size: 18px;
        font-weight: bold;
    }
    .content-title {
        font-weight: bold;
    }
    .content-wrapper {
        margin: 0.75rem 0rem;
    }
    .warning-text {
        margin-top: 1rem;
    }
    .description-content {
        margin: 0 3rem;
    }
    .d-flex {
        display: flex;
    }
    .warning-wrapper {
        display: flex;
        margin-top: 10px;
        align-items: center;
        .divider {
            margin: 0.25rem;
        }
        .inner-content {
            display: flex;
            flex-direction: column;
            .cost-section {
                color: #fff;
                display: flex;
                div:first-child {
                    width: 8rem;
                }
            }
        }
    }
    .seperator {
        border-bottom: 1px solid #707070;
        margin: 2rem 0;
    }
    .sub-title {
        font-weight: bold;
    }
    .text-area {
        border: 1px solid #ABABAB;
        padding: 1rem 4rem 3rem 1rem;
        margin-bottom: 10px;
        height: 400px;
        overflow-y: scroll;
        div {
            margin-bottom: 1rem;
        }
    }
    .button-wrapper {
        margin-top: 2rem;
        .ant-btn {
            width: 100%;
        }
    }
    .user-amount-selector {
        .options {
            display: flex;
            justify-content: space-between;
            span {
                color: #076F00 !important;
            }
            div:first-child {
                width: 10rem;
            }
        }

    }
    .mt-2 {
        margin-top: 2rem;
    }
    .btn-align {
        display: flex;
        justify-content: space-between;
        .ant-btn {
            width: 45%;
        }
    }
    .ant-checkbox {
        .ant-checkbox-inner {
            border: 1px solid #A8A8B1 !important;
        }
    }
    @media(max-width: 960px) {
        .text-area {
            padding: 1rem;
        }
        .user-amount-selector {
            .options {
                display: flex;
                align-items: center;
                div:first-child {
                    width: 6rem;
                }
            }
        }
    }
`;

export default Wrapper;